import { Text } from "@fluentui/react/lib/Text";
import { isNullOrWhiteSpace } from "../../../../../Utils/String";
import { formatCurrency } from "../../../../../Utils/Number";
import { isNullish } from "../../../../../Utils/Null";
import { IValueProps } from "../IValueProps";

export function MoneyValue(props: IValueProps): JSX.Element {
  const {
    fieldName, currencyFieldName, fallbackFieldName, item, placeholder, translator
  } = props;

  return (
    <Text>
      {getFormattedCosts(
        item[fieldName] as number,
        item[currencyFieldName] as string,
        item[fallbackFieldName] as string,
        placeholder,
        translator.getActiveLocale()
      )}
    </Text>
  );
}

function getFormattedCosts(
  value: number,
  currency: string,
  fallback: string,
  placeholder: string,
  locale: string
): string {
  if (isNullish(value) || isNullOrWhiteSpace(currency)) {
    return isNullOrWhiteSpace(fallback) ? placeholder : fallback;
  }

  return formatCurrency(locale, value, currency);
}
